import type { FC, JSX } from "react";

interface TabButtonProps {
    active: boolean;
    onClick: () => void;
    icon: React.ReactNode;
    label: string;
    count?: number;
    badge?: number;
}
const TabButton: FC<TabButtonProps> = ({ 
    active, onClick, 
    icon, label, count, 
    badge 
}): JSX.Element => {
    return (
    <button
      onClick={onClick}
      className={`flex-1 flex items-center justify-center space-x-2 px-6 py-4 font-medium transition-colors relative ${
        active
          ? 'text-green-600 border-b-2 border-green-600 bg-green-50'
          : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
      }`}
    >
      {icon}
      <span>{label}</span>
      {count !== undefined && (
        <span className="text-xs text-gray-500">({count})</span>
      )}
      {badge !== undefined && badge > 0 && (
        <span className="absolute top-2 right-2 w-5 h-5 bg-red-500 text-white text-xs font-bold rounded-full flex items-center justify-center">
          {badge}
        </span>
      )}
    </button>
  );
}

export default TabButton;